import { render, staticRenderFns } from "./RegisterReport.vue?vue&type=template&id=6f8e2a3a&"
import script from "./RegisterReport.vue?vue&type=script&lang=js&"
export * from "./RegisterReport.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports